import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { LocationType, VelavuAPI, VelavuDevice } from "velavu-js-api";
import { makeStyleable } from "../../../../../helper/icon-helper";
import IconPin from "../../../../../dynamicicons/icon-pin";
import DeviceSelectPanel from "../../../../../elements/device-select-panel/device-select-panel";
import FilterableDevicesSource from "../../../../../elements/device-select-panel/filterable-devices-source";

export interface GatewaySelectPanelProps {
	siteID: string;
	onClose?: () => void;
	onSelect?: (device: VelavuDevice) => void;
}

export default function GatewaySelectPanel(props: GatewaySelectPanelProps) {
	const { t } = useTranslation();

	const devicesSource: FilterableDevicesSource = useCallback(
		(filter: string | null) => {
			return (
				VelavuAPI.devices
					.getAllDevices({
						hardware: ["argo"],
						id: filter ?? undefined,
					})
					//Ignore pagination
					.then((result) => result.data)
					.then((devices) =>
						//Ignore devices that are in this site
						devices
							.filter((device) => device.site_id !== props.siteID)
							//Sort devices that are already pinned to the bottom of the list
							.sort((a, b) => {
								const aFixed =
									a.location?.location_type ===
									LocationType.Fixed;
								const bFixed =
									b.location?.location_type ===
									LocationType.Fixed;

								if (aFixed === bFixed) {
									return 0;
								}

								return aFixed ? 1 : -1;
							}),
					)
			);
		},
		[props.siteID],
	);

	return (
		<DeviceSelectPanel
			title={t("dashboard.pin_gateway.select_title")}
			devicesSource={devicesSource}
			showAssetInformation
			getWarningDetails={(device) =>
				device.location?.location_type === LocationType.Fixed
					? t("dashboard.pin_gateway.already_pinned")
					: undefined
			}
			onSelect={props.onSelect}
			buttonLabel={t("common.pin_selected")}
			buttonIcon={makeStyleable(IconPin)}
			onClose={props.onClose}
		/>
	);
}
